export default __webpack_public_path__ + "static/media/iosorandroid.6cd0e338.png";